import React from 'react';
import { Link } from 'react-router-dom';

const Title = () => {
  const features = [
    {
      title: "Blog",
      desc: "Personal blog mainly focussed on travel but with some other personal projects thrown in.",
      image: "/img/features/blog2.jpg",
      url: { url: "/blog", isExternal: false }
    },
    {
      title: "Codefad",
      desc: "Company I founded in 2011 for various tech projects including volunteer consultancy and mobile app development.",
      image: "/img/features/codefad.jpg",
      url: { url: "http://codefad.co.uk", isExternal: true }
    },
    {
      title: "My Music",
      desc: "History of the various bands I've been part of over the years.",
      image: "/img/features/music.jpg",
      url: { url: "/music", isExternal: false }
    },
    {
      title: "Photos",
      desc: "Collection of photos I've taken.",
      image: "/img/features/photos.jpg",
      url: { url: "/photos", isExternal: false }
    }
  ];

  return (
    <>
      <header>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="intro-text">
                <span className="name">Welcome</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {features.map((feature, index) => (
        <section key={index} id="title" style={{ paddingBottom: index === features.length - 1 ? '0' : '0' }}>
          <div className="container" style={{ paddingBottom: '20px' }}>
            <div className="row">
              <div className="col-lg-12 text-center">
                <h2>{feature.title}</h2>
                <hr className="star-primary" />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-lg-offset-2">
                <img className="img-responsive" src={feature.image} alt={feature.title} />
              </div>
              <div className="col-lg-4">
                <p>{feature.desc}</p>
                {feature.url.isExternal ? (
                  <a 
                    className="btn btn-primary" 
                    href={feature.url.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Go To Site
                    &nbsp;<span className="glyphicon glyphicon-chevron-right"></span>
                  </a>
                ) : (
                  <Link 
                    className="btn btn-primary" 
                    to={feature.url.url}
                  >
                    Read More
                    &nbsp;<span className="glyphicon glyphicon-chevron-right"></span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </section>
      ))}
    </>
  );
};

export default Title;
